import * as React from "react";
import {Button, styled} from "@mui/material";
import {AddNewButton} from "./AddNewButton";
import {FriendsNameField} from "./FriendsNameField";
import {SplitMethodField} from "./SplitMethodField";
import {SplitMethodPercentageField} from "./SplitMethodPercentageField";
import {SplitMethodFixedField} from "./SplitMethodFixedField";
import {Details} from "./Details";
import {Currency} from "../../../../../../../config/currencies";
import {ITransactionSplit} from "../../../../../../../config/transactions";
import { useForm } from "../../../../../../../hooks/use_form_v2";
import { Form } from "../../../../../../Components/Form/Form/Form";
import { useModal } from "../../../../../../../hooks/use_modal";
import { validateAmountSplitForm } from "../../../../../../../validators/transactions_details_shared_with_friends";

const Container = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: 'solid 3px',
    borderColor: theme.palette.primary.main,
    borderRadius: 8,
}));

interface IFriendSelectorProps {
    value?: ITransactionSplit;
    onChange(value: ITransactionSplit | null): void;
    originalAmount: string;
    originalCurrency: Currency;
}

export enum SplitMethod {
    PERCENTAGE = "PERCENTAGE",
    FIXED = "FIXED",
}

const DEFAULT_VALUE = {
    name: '',
    split_method: SplitMethod.PERCENTAGE,
    percentage: 50,
    amount: '',
} as any;

export const FriendSelector = ({value, onChange, originalAmount, originalCurrency}: IFriendSelectorProps) => {
    const {open, handleModalOpen, handleModalClose} = useModal(false);

    const form = useForm<ITransactionSplit>(value || DEFAULT_VALUE);
    const { errors, register, watch } = form;

    const handleSubmit = (values: ITransactionSplit) => {
        const validation = validateAmountSplitForm(values);
        if (!validation.isValid()) {
            return Promise.reject(validation);
        }

        onChange(values);
        handleModalClose();

        return Promise.resolve();
    }
    const handleDelete = () => {
        onChange(null);
    };

    if (!!value && !open) {
        return (
            <Details
                value={value}
                originalCurrency={originalCurrency}
                onEdit={handleModalOpen}
                onDelete={handleDelete}
            />
        );
    }

    if (!open) {
        return (
            <AddNewButton onClick={handleModalOpen} />
        );
    }

    return (
        <Container>
            <Form form={form} onSubmit={handleSubmit}>
                <Form.Field type={FriendsNameField} {...register('name')} />
                <Form.Field type={SplitMethodField} {...register('split_method')} gridProps={{xs: 12, md: 4}} />
                <Form.Field
                    form={form}
                    type={SplitMethodPercentageField}
                    originalAmount={originalAmount}
                    originalCurrency={originalCurrency}
                    noWrapper
                    conditional={watch('split_method') === SplitMethod.PERCENTAGE}
                />
                <Form.Field
                    type={SplitMethodFixedField}
                    {...register('amount')}
                    originalCurrency={originalCurrency}
                    conditional={watch('split_method') === SplitMethod.FIXED}
                    gridProps={{ xs: 12, md: 8 }}
                />

                <Form.Buttons position="beforeSubmit">
                    <Button onClick={handleModalClose} variant="contained">
                        Cancel
                    </Button>
                </Form.Buttons>
            </Form>
        </Container>
    );
};
